import { ENV } from '@wolffun/env-var';
export const EXCHANGE_API_ENDPOINT = (() => {
  const apis = {
    production: 'https://exchange.thetanarena.com/exchange/v1',
    uat: 'https://exchange.uat.thetanarena.com/exchange/v1',
    staging: 'https://exchange.staging.thetanarena.com/exchange/v1',
    test: 'https://exchange.staging.thetanarena.com/exchange/v1'
  };
  return apis[ENV];
})();
export const UPDATE_CURRENCY_FREQUENCY = 5 * 60 * 1000; // auto update currency every 5 minutes